import { Grid, Typography, Box, Divider, Stack } from "@mui/material";
import NewMedicalDocumentButtons from "../utils/medicalDocument/NewButtonsForPatient";
import moment from "moment";
import _ from "lodash";
import useFirstMedicalDocument from "./hooks/useFirstMedicalDocument";

const styleSubtittles = {
  fontWeight: 700,
  fontFamily: "Inter",
  color: "primary.main",
};

const styleTexts = {
  fontFamily: "Inter",
  color: "text.black",
  mt: 1,
};

const OrderElements = ({ medicalDocuments }) => {
  const medicalDocument = useFirstMedicalDocument(medicalDocuments);
  const { type } = medicalDocument;
  if (type != "order") return;
  
  return (
    <Grid item xs={12} sm={12}>
      <Stack spacing={3}>
        {
          _.map(medicalDocuments, ({ medicine }, index) => (
            <div key={index}>
              <Typography sx={styleSubtittles}>Solicitud de prácticas</Typography>
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "1fr", //
                      sm: "repeat(2, 1fr)",
                      md: "repeat(3, 1fr)",
                    },
                    gap: 0.5,
                    listStyleType: "disc",
                    padding: 0,
                    margin: 0,
                    ml: 2,
                  }}
                  component="ul"
                >
                  {_(medicine).split("-").compact().map((item, index) => (
                    <Typography component="li" key={index} sx={styleTexts}>
                      {item}
                    </Typography>
                  ))
                  .value()}
                </Box>
              </Grid>
            </div>
          ))
        }
      </Stack>
    </Grid>
  )
};

const DataDetails = ({ medicalDocuments }) => {
  const medicalDocument = useFirstMedicalDocument(medicalDocuments);
  const { patient, diagnosis, medicines, type } = medicalDocument;
  const {
    id,
    name,
    surname,
    documentNumber,
    insuranceNumber,
    healthInsurance,
  } = patient;

  const dates = _(medicalDocuments).map("date").uniq().orderBy().value();
  const severalDates = _.size(dates) > 1;

  const ButtonsRedirect = () => <NewMedicalDocumentButtons patientId={id} />;

  return (
    <Grid item container spacing={2}>
      <Grid
        item
        xs={12}
        sm={12}
        sx={{
          display: { xs: "flex", sm: "flex", md: "none" },
          alignItems: "center",
          justifyContent: { xs: "space-between", sm: "start" },
        }}
      >
        <ButtonsRedirect />
      </Grid>

      <Grid item xs={12} sm={5}>
        <Typography sx={styleSubtittles}>Datos del Paciente</Typography>
        <Typography sx={styleTexts}>
          Apellido y Nombre(s): {surname || ""}, {name || ""}
        </Typography>
        <Typography sx={styleTexts}>DNI: {documentNumber || ""}</Typography>
      </Grid>

      <Grid item xs={12} sm={3}>
        <Typography sx={styleSubtittles}>Cobertura</Typography>
        <Typography sx={styleTexts}>{healthInsurance || ""}</Typography>
        <Typography sx={styleTexts}>
          Nro Afiliado: {insuranceNumber || ""}
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sm={4}
        sx={{
          display: { xs: "none", sm: "none", md: "flex" },
          alignItems: "center",
          justifyContent: "end",
        }}
      >
        <ButtonsRedirect />
      </Grid>

      <Grid item xs={12} sm={12} mt={1} mb={1}>
        <Divider />
      </Grid>

      <Grid item xs={12} sm={12}>
        <Typography sx={styleSubtittles}>{`Fecha${severalDates ? "s" : ""}`}</Typography>
        {
          _(dates).map((date, index) => (
            <Typography sx={styleTexts} component={severalDates ? "li" : "p"} key={index}>
              {moment(date).format("DD/MM/YYYY")}
            </Typography>
          )).value()
        }
      </Grid>

      <Grid item xs={12} sm={12} mt={1} mb={1}>
        <Divider />
      </Grid>

      <Grid item xs={12} sm={12}>
        <Typography sx={styleSubtittles}>Diagnóstico</Typography>
        <Typography sx={styleTexts}>{diagnosis || ""}</Typography>
      </Grid>

      <Grid item xs={12} sm={12} mt={1} mb={1}>
        <Divider />
      </Grid>

      {type === "prescription" && (
        <Grid item xs={12} sm={12}>
          <Typography sx={styleSubtittles}>Medicamentos</Typography>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr", //
                },
                gap: 0.5,
                listStyleType: "disc",
                padding: 0,
                margin: 0,
                ml: 2,
              }}
              component="ul"
            >
              {medicines.map((item, index) => (
                <Typography component="li" key={index} sx={styleTexts}>
                  {item.text} {item.posology ? " / " + item.posology : ""}
                </Typography>
              ))}
            </Box>
          </Grid>
        </Grid>
      )}

      <OrderElements medicalDocuments={medicalDocuments} />
    </Grid>
  );
};

export default DataDetails;
